export default __webpack_public_path__ + "static/media/plus-icon-filled-secondary.f7b49e9d.svg";